import { createRouter, createWebHistory } from "vue-router";
import BemVindo from "@/components/BemVindo.vue";
import QuizGame from "@/components/QuizGame.vue";
import QuizGameRas from "@/components/QuizGameRas.vue";
import QuizGameWorld from "@/components/QuizGameWorld.vue";
import QuizDynamic from "@/components/QuizDynamic.vue"; // Novo componente dinâmico
import QuebraCabeca1View from "@/views/QuebraCabeca1View.vue"; // Nova view QB
import QuebraCabeca2View from "@/views/QuebraCabeca2View.vue"; // Nova view QB
import rouletteGameView from "@/views/rouletteGameView.vue"; // Nova view QB

import MemoryGameView from "@/views/MemoryGameView.vue"; // Jogo da Memória


const routes = [
  {
    path: "/",
    name: "BemVindo",
    component: BemVindo,
  },
  {
    path: "/quiz",
    name: "QuizGame",
    component: QuizGame,
  },
  {
    path: "/quizras",
    name: "QuizGameRas", // Certifique-se de que esta rota está sendo usada
    component: QuizGameRas,
  },
  {
    path: "/quizras/:categoryId",
    name: "QuizDynamic",
    component: QuizDynamic,
    props: true, // Passa o parâmetro categoryId como prop para o componente
  },
  {
    path: "/quizworld",
    name: "QuizGameWorld",
    component: QuizGameWorld,
  },
  {
    path: "/qb1",
    name: "QuebraCabeca1View",
    component: QuebraCabeca1View,
  },
  {
    path: "/qb2",
    name: "QuebraCabeca2View",
    component: QuebraCabeca2View,
  },
  {
    path: "/mg1",
    name: "MemoryGameView",
    component: MemoryGameView,
  },
  {
    path: "/roleta",
    name: "rouletteGameView",
    component: rouletteGameView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
